<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import RangeSlider from "../../../inputs/RangeSlider.vue";

const store = useStore();

// Auto leaves the length to the genie until the slider is moved
const auto = computed(() => !store.state.length.hasMoved);
const setAuto = () => store.dispatch("length/setAuto");
</script>

<template>
  <section>
    <div class="mb-2 flex flex-col lg:mb-4">
      <p class="mb-1 text-base font-bold text-primary">Length</p>
      <p class="mb-7 text-sm text-secondary">
        Leave it on Auto for the genie to choose, or slide to pick one.
      </p>
      <div class="flex items-start">
        <button
          type="button"
          class="-mt-[15px] flex shrink-0 items-center rounded-full px-4 py-2 text-sm font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accentPrimary"
          :class="
            auto
              ? 'bg-accentSecondary text-primary'
              : 'bg-gray-10 text-secondary hover:bg-gray-100 hover:text-primary'
          "
          :aria-pressed="auto"
          title="Let the genie pick a length that suits it"
          @click="setAuto"
        >
          <font-awesome-icon
            :icon="['fas', 'wand-magic-sparkles']"
            class="mr-1.5"
          />
          Auto
        </button>
        <RangeSlider class="mb-14 min-w-0 flex-1" />
      </div>
    </div>
  </section>
</template>
